import firebase from 'firebase/app'
import { Module } from 'vuex'
import { RootState } from '..'


export interface KeyBindings {
  [id: string]: string
  PreviousImage: string
  NextImage: string
  FlagImage: string
  ApproveImage: string
  ShiftUp: string
  ShiftDown: string
  ShiftLeft: string
  ShiftRight: string
}
export interface SettingsState {
  showContrastBadgesToggle: boolean
  showImageNumberBadgesToggle: boolean
  showImageEditCheck: boolean
  showOnlyPreferredImagesToggle: boolean
  showOnlyUnapprovedImagesToggle: boolean
  keyBindings: KeyBindings
  keyOrder: string[]
}

enum mutations {
  SETTINGS_LOADED = 'SETTINGS_LOADED',
  SHOW_CONTRAST_BADGES = 'SHOW_CONTRAST_BADGES',
  SHOW_IMAGE_NUMBER_BADGES = 'SHOW_IMAGE_NUMBER_BADGES',
  SHOW_IMAGE_EDIT_CHECK = 'SHOW_IMAGE_EDIT_CHECK',
  SHOW_ONLY_PREFERRED_IMAGES = 'SHOW_ONLY_PREFERRED_IMAGES',
  SHOW_ONLY_UNAPPROVED_IMAGES = 'SHOW_ONLY_UNAPPROVED_IMAGES',
  KEY_MAPPINGS = 'KEY_MAPPINGS'
}

export const settings: Module<SettingsState, RootState> = {
  namespaced: true,
  state: {
    showContrastBadgesToggle: true,
    showImageNumberBadgesToggle: true,
    showImageEditCheck: true,
    showOnlyPreferredImagesToggle: false,
    showOnlyUnapprovedImagesToggle: false,
    keyBindings: {
      NextImage: 'x',
      PreviousImage: 'z',
      FlagImage: 'f',
      ApproveImage: 'a',
      ShiftUp: 'ArrowUp',
      ShiftDown: 'ArrowDown',
      ShiftLeft: 'ArrowLeft',
      ShiftRight: 'ArrowRight'
    },
    keyOrder: [
      'PreviousImage',
      'NextImage',
      'FlagImage',
      'ApproveImage',
      'ShiftUp',
      'ShiftDown',
      'ShiftLeft',
      'ShiftRight'
    ]
  },
  getters: {
    ref: (state, getters, rootState, rootGetters) => rootGetters['profile/collection'].doc('settings')
  },
  actions: {
    async init ({ commit, getters }) {
      const snapshot = await getters.ref.get() as firebase.firestore.DocumentSnapshot
      if (snapshot.exists) {
        const settings = snapshot.data() as Partial<SettingsState>
        if (settings.showContrastBadgesToggle !== undefined) {
          commit(mutations.SHOW_CONTRAST_BADGES, settings.showContrastBadgesToggle)
        }
        if (settings.showContrastBadgesToggle !== undefined) {
          commit(mutations.SHOW_IMAGE_NUMBER_BADGES, settings.showImageNumberBadgesToggle)
        }
        if (settings.showOnlyPreferredImagesToggle !== undefined) {
          commit(mutations.SHOW_ONLY_PREFERRED_IMAGES, settings.showOnlyPreferredImagesToggle)
        }
        if (settings.showOnlyUnapprovedImagesToggle !== undefined) {
          commit(mutations.SHOW_ONLY_UNAPPROVED_IMAGES, settings.showOnlyUnapprovedImagesToggle)
        }
        if (settings.showImageEditCheck !== undefined) {
          commit(mutations.SHOW_IMAGE_EDIT_CHECK, settings.showImageEditCheck)
        }
        if (settings.keyBindings !== undefined) {
          console.log(settings.keyBindings)
          commit(mutations.KEY_MAPPINGS, settings.keyBindings)
        }
      }
    },
    showContrastBadgesToggled ({ commit, getters }, payload: boolean) {
      commit(mutations.SHOW_CONTRAST_BADGES, payload)

      const ref = getters.ref as firebase.firestore.DocumentReference
      return ref.set({ showContrastBadgesToggle: payload }, { merge: true })
    },
    showImageNumberBadgesToggle ({ commit, getters }, payload: boolean) {
      commit(mutations.SHOW_IMAGE_NUMBER_BADGES, payload)

      const ref = getters.ref as firebase.firestore.DocumentReference
      return ref.set({ showImageNumberBadgesToggle: payload }, { merge: true })
    },
    showImageEditCheck ({ commit, getters }, payload: boolean) {
      commit(mutations.SHOW_IMAGE_EDIT_CHECK, payload)

      const ref = getters.ref as firebase.firestore.DocumentReference
      return ref.set({ showImageEditCheck: payload }, { merge: true })
    },
    showOnlyUnapprovedImagesToggle ({ commit, getters }, payload: boolean) {
      commit(mutations.SHOW_ONLY_UNAPPROVED_IMAGES, payload)

      const ref = getters.ref as firebase.firestore.DocumentReference
      return ref.set({ showOnlyUnapprovedImagesToggle: payload }, { merge: true })
    },
    showOnlyPreferredImagesToggled ({ commit, getters }, payload: boolean) {
      commit(mutations.SHOW_ONLY_PREFERRED_IMAGES, payload)

      const ref = getters.ref as firebase.firestore.DocumentReference
      return ref.set({ showOnlyPreferredImagesToggle: payload }, { merge: true })
    },
    keyMappingsUpdated ({ commit, getters }, payload: { binding: string; key: string }) {
      const newBindings = this.state.profile.settings.keyBindings
      newBindings[payload.binding] = payload.key
      commit(mutations.KEY_MAPPINGS, newBindings)

      const ref = getters.ref as firebase.firestore.DocumentReference
      const data: Partial<SettingsState> = {
        keyBindings: newBindings
      }
      return ref.set(data, { merge: true })
    }
  },
  mutations: {
    [mutations.SHOW_IMAGE_NUMBER_BADGES] (state, payload) {
      state.showImageNumberBadgesToggle = payload
    },
    [mutations.SHOW_CONTRAST_BADGES] (state, payload) {
      state.showContrastBadgesToggle = payload
    },
    [mutations.SHOW_ONLY_PREFERRED_IMAGES] (state, payload) {
      state.showOnlyPreferredImagesToggle = payload
    },
    [mutations.SHOW_ONLY_UNAPPROVED_IMAGES] (state, payload) {
      state.showOnlyUnapprovedImagesToggle = payload
    },
    [mutations.SHOW_IMAGE_EDIT_CHECK] (state, payload) {
      state.showImageEditCheck = payload
    },
    [mutations.KEY_MAPPINGS] (state, payload) {
      state.keyBindings = payload
    }
  }
}
